import { Redirect, Route, useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { LayoutUnlogged } from '../Components/Layout/LayoutUnlogged'
import { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../Auth/AuthContext'
import LoadingLayer from '../Components/Global/LoadingLayer'

localStorage.removeItem('pageRequest')
localStorage.setItem('pageRequest', window.location.pathname)

export const PublicRoute = ({
  isAuth,
  userType,
  component: Component,
  ...rest
}) => {
  const { user } = useContext(AuthContext)

  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const [path, setPath] = useState('/dashboardMigrants/logged')

  useEffect(() => {
    setLoading(true)
    if (isAuth) {
      // if(user?.userPermissions){
      //   let index = 0
      //   if(user?.userPermissions.length > 1 && user?.userPermissions[index].module_info?.relative_link === '/profile') index = 1
      //   let path = user?.userPermissions[index].module_info?.relative_link
      //   let subPath = user?.userPermissions[index]?.submodule_info?.relative_link
      //   if (subPath) {
      //     path = path + subPath
      //   }
      //   setPath(path)
      //   history.push(path)
      // }
      setLoading(false)
    }else if(!isAuth) setLoading(false)
  }, [isAuth])

  return (
    <Route
      {...rest}
      component={(props) =>
        isAuth ? (
          <>{loading ? <LoadingLayer /> : <Redirect to={path} />}</>
        ) : (
          <LayoutUnlogged>
            <Component {...props} />
          </LayoutUnlogged>
        )
      }
    />
  )
}

PublicRoute.prototype = {
  isAuth: PropTypes.bool.isRequired,
  userType: PropTypes.number.isRequired,
  component: PropTypes.func.isRequired,
}
